<template>
<!-- 查看信的信息 -->
  <div v-if="bodyShow" class="check-mail  animated fadeInRight">
      <img class="bg" src="https://themes-cdn.xjy.cn/statics/career/images/ceping82/mail-bg.png" alt="">
      <h3 class="title">{{item.name}}：</h3>
      <!-- label -->
      <div class="label-group">
          <img v-for="(child,index) in item.flashPoint" :key="index"  class="label"  :src="`https://themes-cdn.xjy.cn/statics/career/images/ceping82/b${(arrList.indexOf(child))+1}.png`" alt="">
      </div>
      <!-- 我想对你说 -->
      <div class="text-box">
          <h4>我想对你说：</h4>
          <p>{{item.blessing[0]}}</p>
      </div>
      <!-- 署名 -->
      <div class="signature">
          <p>From:{{item.from}}<br/>{{item.update_time?item.update_time.split(' ')[0]:''}}</p>
      </div>
      <!-- btn -->
      <button class="addbtn" @click="$router.push('/ceping82')">我要写信</button>
  </div>
</template>

<script>
import { getData,saveData,ceping82_get_data,ceping82_save_data,ceping82_get_data_list } from '@/api/measurement'
import { deepCopy,isMain } from "@/utils/tools";
import { shareCon } from "@/utils/wxconfig";
export default {
    data(){
        return{
            bodyShow:false,
            arrList:['好奇心','创造性','洞察力','勇敢','勤勉','正直','仁慈','爱','同理心','责任','公平','领导力','自控力','谨慎','谦虚','希望','幽默','热枕'],
            cid:82,
            item:{}
        }
    },
    methods:{
        // 初始化获取数据
        pullData(){
            document.title = '查看信件';
            let q = this.$route.query;
            if(!q.md5){
                this.$toast('地址参数错误，请返回重试！');
                return
            }
            //调用加载中
            this.$emit('loadingHandle',true,"正在打开信件ヾ(◍°∇°◍)ﾉﾞ...");
            ceping82_get_data({
                cid:this.cid,
                md5:q.md5
            }).then((data)=>{
                //关闭加载中
                this.$emit('loadingHandle',false);
                if (data.code == "10002") {
                    this.$toast(data.data.msg || data.msg || data.data.detail);
                    return
                }
                this.item =data.item && JSON.parse(data.item.data)?JSON.parse(data.item.data):{};
                this.bodyShow = true;
                shareCon("index", this);
                if(q.type && q.type=='poster'){
                    getData({
                        cid:this.cid
                    }).then(res=>{
                        if(res.data){
                            let mailData = JSON.parse(res.data);
                            let mailList =mailData && mailData.mailList?mailData.mailList:[];
                            let bool = false;
                            mailList.map(v=>{
                                if(v.md5==data.item.md5){
                                    bool = true;
                                }
                            });
                            if(!bool || mailList.length==0){
                                mailData['mailList'] = [...mailList,data.item];
                                // 保存已收信
                                saveData({
                                    cid:this.cid,
                                    data:JSON.stringify(mailData)
                                }).then((res2)=>{

                                    if (res2.code == "10002") {
                                        this.$toast(res2.data.msg || res2.msg || res2.data.detail);
                                        return
                                    }
                                });
                            }
                            
                        }else{
                            let mailData = {};
                            mailData['mailList'] = [data.item];
                            // 保存已收信
                            saveData({
                                cid:this.cid,
                                data:JSON.stringify(mailData)
                            }).then((res2)=>{

                                if (res2.code == "10002") {
                                    this.$toast(res2.data.msg || res2.msg || res2.data.detail);
                                    return
                                }
                            });
                        }
                    });
                }
            });

            
        }
    },
    created(){
        this.pullData();
    }
}
</script>
<style lang="scss">
    body{
        background:url('https://themes-cdn.xjy.cn/statics/career/images/ceping82/bg-cover.png') bottom;
    }
</style>
<style lang="scss" scoped>
.check-mail{
    position: relative;
    width: 100%;
    .bg{
        width: 100%;
        z-index: -1;
    }
    .title{
        position: absolute;
        left: 95px;
        top: 146px;
        font-size: 30px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #875233;
        line-height: 42px;
    }
    .label-group{
        position: absolute;
        left: 85px;
        top: 378px;
        display: flex;
        align-items: center;
        .label{
            width: 180px;
            &:nth-child(2){
                margin: 0 20px;
            }
        }
    }
    .text-box{
        position: absolute;
        top: 810px;
        left: 95px;
        h4{
            font-size: 30px;
            width: 560px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #875233;
            line-height: 42px;
        }
        p{
            width: 560px; 
            font-size: 30px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #875233;
            line-height: 58px;
        }
    }
    .signature{
        position: absolute;
        top: 1034px;
        right: 95px;
        width: 560px;
        p{
            width: 560px;
            font-size: 30px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #875233;
            line-height: 48px;
            text-align: right;
        }
    }
    .addbtn{
        position: absolute;
        top: 1162px;
        left: 225px;
        width: 300px;
        height: 80px;
        background: linear-gradient(180deg, #FF855D 0%, #D13E1D 100%);
        box-shadow: 0px 2px 6px 0px rgba(179, 31, 0, 0.43);
        border-radius: 40px;
        font-size: 36px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #FFFFFF;
        text-shadow: 0px 2px 4px rgba(221, 41, 0, 0.5);
        border:none;
        animation: scaleDraw 2s  infinite;
    }
}
</style>